import { render } from "./CollectorPerformanceRankings.vue?vue&type=template&id=54820980&scoped=true"
import script from "./CollectorPerformanceRankings.vue?vue&type=script&lang=js"
export * from "./CollectorPerformanceRankings.vue?vue&type=script&lang=js"

import "./CollectorPerformanceRankings.vue?vue&type=style&index=0&id=54820980&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54820980"]])

export default __exports__